export const categories = [
  {
    slug: "response",
    name: "本人回应",
    desc: "整理灵灵本人在社交平台发布的回应全文要点、直播说明与后续补充，保留原始表述，不做情绪化转述。",
    icon: "ri-megaphone-line",
  },
  {
    slug: "statement",
    name: "声明解读",
    desc: "对工作室与相关方的声明逐句拆解，标注其中留有余地的表述、法律措辞的含义以及未直接回应的部分。",
    icon: "ri-file-text-line",
  },
  {
    slug: "debunk",
    name: "辟谣分析",
    desc: "针对流传最广的截图、聊天记录与匿名爆料，逐条核对来源、时间戳与上下文，给出「已证实 / 待确认 / 已辟谣」判断。",
    icon: "ri-shield-check-line",
  },
  {
    slug: "progress",
    name: "后续进展",
    desc: "按时间顺序持续更新事件的新节点，包括平台公告、账号状态变化、公开信息补充与各方最新表态。",
    icon: "ri-timeline-view",
  },
];